import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Adempimento } from '../../../common/models/adempimento';
import { ScadenzaResponse } from '../../../common/models/dto/scadenza-response';
import { CssClassMapping } from '../../configuration/css-class-mapping';
import { FrontEndMapping } from '../../configuration/front-end-mapping';

import { ServicePathsSettings } from '../../configuration/service-paths-settings';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { ModalNotifyService } from '../../services/modal-notify.service';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { ScadenzaEvadiComponent } from 'src/app/common/components/fascicolo/scadenza-evadi/scadenza-evadi.component';
import { DialogService } from '../dialog/dialog.service';

declare var getFascicoloMapSync;

@Component({
  selector: "[prossimi-adempimenti-list]",
  templateUrl: "prossimi-adempimenti-list.component.html",
})
export class ProssimiAdempimentiListComponent implements OnInit {
  @Input() viewOption: boolean = false; // settato a false temporaneamente manca integrazione metodi di rinvio/evadi
  @Input() adempimenti: Adempimento[] = [];
  @Input() slice: number;
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  @Output() rinvia: EventEmitter<Adempimento> = new EventEmitter<Adempimento>();
  private subscriptionEvadi: Subscription;

  constructor(
    private viewManager: ViewManagerService,
    protected operationService: OperationsService,
    private router: Router,
    private frontEndMapping: FrontEndMapping,
    private modalNotifyService: ModalNotifyService,
    private dialog: DialogService
  ) {}

  ngOnInit() {
    if (this.slice > 0 && this.slice < this.adempimenti.length) {
      this.adempimenti = this.adempimenti.slice(0, this.slice);
    }
  }

  goToSezScadenza(idTipoFascicolo: string, idTipoPratica: string, idFascicolo: string) {
    let nomePraticaFE = "";
    this.frontEndMapping.getListTipiPratica(idTipoPratica).subscribe((res) => {
      nomePraticaFE = res;
    });
    // let nomePraticaFE = FrontEndMapping.tipiPratica[Number(idTipoPratica)];
    let nomeFascicoloFE = "";
    this.frontEndMapping
      .getListTipiFascicolo(idTipoFascicolo)
      .subscribe((res) => {
        nomeFascicoloFE = res;
      });
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[Number(idTipoFascicolo)];
    localStorage.setItem("fromAdempimenti", "true");
    this.router.navigate([
      "/fascicolo/" +
        nomePraticaFE +
        "/" +
        nomeFascicoloFE +
        "/" +
        UrlSettingsCore.URL_VISUALIZZA_SEZIONE_SCADENZARIO +
        "/" +
        idFascicolo,
    ]);
  }

  evadiAdempimento(adempimento){
    this.subscriptionEvadi = this.modalNotifyService.notifyConfirmObservable.subscribe(
      (result) => {
        if (!!result) {
          this.openDialogEvadi(result, adempimento.id);
        }
        else{
          this.subscriptionEvadi.unsubscribe();
        }
      });
    this.modalNotifyService.notifyEvadiScadenza();
  }

  openDialogEvadi(result: boolean, idScadenza: string) {
    this.subscriptionEvadi.unsubscribe();
    const ref = this.dialog.open(ScadenzaEvadiComponent, {
      data: {
        style: {
          width: '50%',
          overflow: false
        },
        idAdempimento: idScadenza,
        title: 'Evadi adempimento',
      }
    });
    ref.afterClosed.subscribe((event) => {
      if(!event || event.closeEvent) return;
      if(event.dataEvasione) {
        let payload = {
          dataEvasione: event.dataEvasione, 
          motivoEvasione: event.motivoEvasione
        };
        this.executeEvasione(result, idScadenza, payload)
      }
    });
  }

  executeEvasione(result: boolean, idScadenza: string, payload) {
    if (result) {
     this.operationService.evadiAdempimentoParams(ServicePathsSettings.URL_EVADI_ADEMPIMENTO, idScadenza, payload).
       subscribe(response => this.resultEvadi(response));
    }
    if (this.subscriptionEvadi) {
      this.subscriptionEvadi.unsubscribe();
    }
  }

  rinviaAdempimento(adempimento) {
    this.rinvia.emit(adempimento);
  }

  resultEvadi(response: ScadenzaResponse) {
    if (response.returnCode == "OK") {
      let ind = this.adempimenti.findIndex((a) => a.id === response.scadenza.id);
      this.adempimenti.splice(ind, 1);
      this.viewManager._prossimiAdempimenti.next({
        param: response,
        timeOut: false,
      });
      this.onReturn.emit();
    }
  }

  getClassNameTipoScadenza(id: string) {
    return CssClassMapping.cssTipoScadenza[id];
  }

  getClassNameTipoPriorita(id: string) {
    return CssClassMapping.cssNameTipoPriorita[id];
  }

  getClassColorTipoPriorita(id: string) {
    return CssClassMapping.cssColorTipoPriorita[id];
  }
}
